// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConditionInput } from './ConditionInput';
import {
  ConditionInputFromJSON,
  ConditionInputFromJSONTyped,
  ConditionInputToJSON,
  ConditionInputToJSONTyped,
} from './ConditionInput';

/**
 *
 * @export
 * @interface IsolationUnitStatusPatch
 */
export interface IsolationUnitStatusPatch {
  /**
   *
   * @type {string}
   * @memberof IsolationUnitStatusPatch
   */
  awsAccountId?: string;
  /**
   *
   * @type {string}
   * @memberof IsolationUnitStatusPatch
   */
  azureSubscriptionId?: string;
  /**
   *
   * @type {Array<ConditionInput>}
   * @memberof IsolationUnitStatusPatch
   */
  conditions?: Array<ConditionInput>;
  /**
   *
   * @type {string}
   * @memberof IsolationUnitStatusPatch
   */
  gcpProjectId?: string;
}

/**
 * Check if a given object implements the IsolationUnitStatusPatch interface.
 */
export function instanceOfIsolationUnitStatusPatch(
  value: object,
): value is IsolationUnitStatusPatch {
  return true;
}

export function IsolationUnitStatusPatchFromJSON(
  json: any,
): IsolationUnitStatusPatch {
  return IsolationUnitStatusPatchFromJSONTyped(json, false);
}

export function IsolationUnitStatusPatchFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IsolationUnitStatusPatch {
  if (json == null) {
    return json;
  }
  return {
    awsAccountId:
      json['aws_account_id'] == null ? undefined : json['aws_account_id'],
    azureSubscriptionId:
      json['azure_subscription_id'] == null
        ? undefined
        : json['azure_subscription_id'],
    conditions:
      json['conditions'] == null
        ? undefined
        : (json['conditions'] as Array<any>).map(ConditionInputFromJSON),
    gcpProjectId:
      json['gcp_project_id'] == null ? undefined : json['gcp_project_id'],
  };
}

export function IsolationUnitStatusPatchToJSON(
  json: any,
): IsolationUnitStatusPatch {
  return IsolationUnitStatusPatchToJSONTyped(json, false);
}

export function IsolationUnitStatusPatchToJSONTyped(
  value?: IsolationUnitStatusPatch | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    aws_account_id: value['awsAccountId'],
    azure_subscription_id: value['azureSubscriptionId'],
    conditions:
      value['conditions'] == null
        ? undefined
        : (value['conditions'] as Array<any>).map(ConditionInputToJSON),
    gcp_project_id: value['gcpProjectId'],
  };
}
